import { Typography } from '@mui/material';
import React, { Fragment } from 'react';

import type { ImmunizationRecord } from '@models/immunization';

import { formatFacility } from '@utils/format';
import { sortImmunizations } from '@utils/sort/records';

import ImmunizationCard from './ImmunizationCard';

function ImmunizationRow({
  immunizations,
  hideExpiry = false,
  title = '',
}: {
  immunizations: ImmunizationRecord[];
  hideExpiry?: boolean;
  title?: string;
}) {
  if (immunizations.length === 0) return null;
  return (
    <Fragment key={title}>
      <Typography variant="overline">{title}</Typography>
      {immunizations.sort(sortImmunizations).map((i) => {
        const immunizationName = i.vaccineName;
        return (
          <ImmunizationCard
            key={i.id}
            brand={i.brand}
            dateExpires={i.getExpiryDateStr()}
            dateReceived={i.getImmunizationDateStr()}
            dose={i.dose}
            hideExpiry={hideExpiry}
            id={i.id}
            location={formatFacility(i.facility, i.address)}
            lot={i.lotNumber}
            provider={i.practitioner}
            recordSource={i.recordSource}
            selfReported={Boolean(i.selfReported)}
            status={i.curationStatus}
            type={immunizationName}
            patient={i.getPatient()}
          />
        );
      })}
    </Fragment>
  );
}

export default ImmunizationRow;
